import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTransferImportResponse } from '../../services/dataTransferService';

interface ImportResultsProps {
  result: DataTransferImportResponse | null;
}

const ImportResults: React.FC<ImportResultsProps> = ({ result }) => {
  const { t } = useTranslation();

  if (!result) {
    return (
      <p className="text-muted mb-0" data-testid="results-empty">
        {t('dataTransfer.noResults')}
      </p>
    );
  }

  const { summary, details } = result;

  return (
    <div data-testid="results-panel">
      <div className="row text-center mb-3">
        <div className="col">
          <div className="fs-3" data-testid="results-created-count">
            {summary.created}
          </div>
          <div className="text-muted">{t('dataTransfer.created')}</div>
        </div>
        <div className="col">
          <div className="fs-3" data-testid="results-updated-count">
            {summary.updated}
          </div>
          <div className="text-muted">{t('dataTransfer.updated')}</div>
        </div>
        <div className="col">
          <div className="fs-3" data-testid="results-skipped-count">
            {summary.skipped}
          </div>
          <div className="text-muted">{t('dataTransfer.skipped')}</div>
        </div>
        <div className="col">
          <div
            className={`fs-3${summary.errors > 0 ? ' text-danger' : ''}`}
            data-testid="results-errors-count"
          >
            {summary.errors}
          </div>
          <div className="text-muted">{t('dataTransfer.errors')}</div>
        </div>
      </div>
      {details.errorDetails.length > 0 && (
        <ul className="list-unstyled">
          {details.errorDetails.map((e, i) => (
            <li key={`e-${i}`} className="py-1 px-2">
              <strong>Row {e.row}</strong> — &quot;{e.identifier}&quot;: {e.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ImportResults;
